module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qabdo3-b1447366984a0431acac6f06f282ae44.jpg";